import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux"
import { store } from "./store"
import { render } from "react-dom"; 

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// the change to render is necessary for the React WYSIWYG toolbar dropdowns to work
root.render(
  <React.StrictMode>
    <Provider store={store}>
   			<App/>
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
